import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import GroupsComponent from './PlaylistGroups/GroupsComponent'
import Playlists from './playlists/Playlists'
import VideoPlayer from './videoPlayler/VideoPlayer'
import AnalyzeComponent from './analyze/AnalyzeComponent'
import CurrentPlaylist from './playlists/CurrentPlaylist'
import Genres from './landing/Genres'
import Concerts from './landing/Concerts'
import BottomComponent from './landing/BottomComponent'

export default function Home(props) {

    const navigate = useNavigate()
    const playerRef = useRef()
    const analyzeRef = useRef()

    const [searchParams, setSearchParams] = useSearchParams([])
    const [currentTime, setCurrentTime] = useState(0)

    const [videoId, setVideoId] = useState(null)
    const [playlistId, setPlaylistId] = useState(null)

    const [ playing, setPlaying ] = useState(false)

    const [videoInfoExpanded, setVideoInfoExpanded] = useState(false)

  // Get group id from URL or localStorage or default to 4
    const groupId = parseInt(searchParams.get('g')) ||
                    parseInt(localStorage.getItem('group_id')) || 4

    // ⏪ Handle rewind button
    const handleReWind = () => {
        if (playerRef.current) {
            setCurrentTime(Math.round(playerRef.current.getCurrentTime()))
        }
    }


    // 🧭 Redirect to login if unauthenticated (handled safely in useEffect)
    useEffect(() => {
        if (!props.userLoading && (!props.user || !props.user.id)) {
            searchParams.get('v') && localStorage.setItem('video_id', searchParams.get('v'))
            searchParams.get('p') && localStorage.setItem('playlist_id', searchParams.get('p'))
            searchParams.get('g') && localStorage.setItem('group_id', searchParams.get('g'))
            navigate('/login', { replace: true })
        }
    }, [props.user, props.userLoading])


    useEffect(() => {
        let v_id = parseInt(searchParams.get('v')) ? parseInt(searchParams.get('v')) : localStorage.getItem('video_id') ? localStorage.getItem('video_id') : null
        let p_id = searchParams.get('p') ? searchParams.get('p') : localStorage.getItem('playlist_id') ? localStorage.getItem('playlist_id') : null
        localStorage.setItem('path', `/home?p=${searchParams.get('p')}&v=${searchParams.get('v')}&g=${searchParams.get('g')}`)
        setVideoId(v_id)
        setPlaylistId(p_id)
        setPlaying(true)
        setVideoInfoExpanded(false)
    }, [searchParams])


    const videoClickHandler = (v) => {
        const currentVideo = searchParams.get('v')
        if (currentVideo !== v.id.toString()) {
            setSearchParams({ ...Object.fromEntries([...searchParams]), v: v.id })
            localStorage.setItem('video_id', v.id)
        }
    }

    // 🎞️ Playlist or group click
    const slideClickHandler = (data) => {
        const video = data.video?.id || data.video_id
        if (video) {
            setSearchParams({ ...Object.fromEntries([...searchParams]), p: data.id, v: video })
            localStorage.setItem('video_id', video)
            localStorage.setItem('playlist_id', data.id)
        }
    }

  // 🧩 On group click
    const onGroupClick = (group) => {
        props.setActiveGroup(group)
        setSearchParams({ ...Object.fromEntries([...searchParams]), g: group.id }, { replace: true })
        localStorage.setItem('group_id', group.id)
        props.groupsRef.current?.scrollIntoView({ behavior: 'smooth' })
    }

  // 🌀 Loading state
  if (props.userLoading) {
    return (
      <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center"
           style={{ background: "linear-gradient(#051932, #07294C)" }}>
        <div className="spinner-border text-info" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  // 🚪 If user not logged in (redirect handled by useEffect)
  if (!props.user || !props.user.id) {
    return null // prevent flicker before redirect
  }

  // ✅ Authenticated UI
  return (
    <div className='w-100 bg-bluedark d-flex flex-column align-items-center'>

        <VideoPlayer
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            handleRewind={handleReWind}
            playerRef={playerRef}
            analyzeRef={analyzeRef}
            videoClickHandler = {videoClickHandler}
            videoId={videoId}
            playlistId={playlistId}
            filterList={props.filterList}
            playing={playing}
            setPlaying={setPlaying}
            videoInfoExpanded={videoInfoExpanded}
            setVideoInfoExpanded={setVideoInfoExpanded}
        />
{/*
      <AnalyzeButtonForSmall handleRewind={handleReWind} /> */}

      <AnalyzeComponent
        currentTime={currentTime}
        analyzeRef={analyzeRef}
        videoInfoExpanded={videoInfoExpanded}
        />

      <CurrentPlaylist
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        videoClickHandler = {videoClickHandler}
        />

      <Playlists
        slideClickHandler={slideClickHandler}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        myPlaylistsRef={props.myPlaylistsRef}
      />

      <Concerts
        user={props.user}
        slidesToShow={1}
        slideClickHandler={slideClickHandler}
      />

      <Genres
        user={props.user}
        setFilterList={props.setFilterList}
        setActiveComponent={props.setActiveComponent}
        />

      <GroupsComponent
        activeGroup={props.activeGroup}
        setActiveGroup={props.setActiveGroup}
        onGroupClick={onGroupClick}
        slideClickHandler={slideClickHandler}
        group_id={groupId}
        groupsRef={props.groupsRef}
      />

      <BottomComponent
        user={props.user}
        setFilterList={props.setFilterList}
        setActiveComponent={props.setActiveComponent}
    />

      <div className='w-100 bg-bluedark' style={{ height: '150px' }} />
    </div>
  )
}
